import { MultiDateInputFieldValue } from 'customer/components/ui-elements/MultiDateInput/MultiDateInput.types'

export type BridalFairsContainerProps = {
  primaryColor?: string
}

export type BridalFairsProps = {
  className?: string
  primaryColor?: string
  viewTitle?: string | null
} & BridalFairsContainerProps

export type BridalFair = {
  minutes: number
  fairTimes: FairTime[]
  bridalFairDetails: BridalFairDetail[]
}

export type FairTime = {
  startAt: Date
  availability: 'lot' | 'few' | 'none'
}

export type BridalFairDetail = {
  key: string
  name: string
  applicableStartDate: Date | null
  applicableEndDate: Date | null
  mainImageUrl: string
  descriptionText: string
  order: number
  pricing: 'free' | 'paid' | 'partially_paid'
  fairTags: { id: string; name: string }[]
  fairContents: { id: string; name: string }[]
  bridalSpecialOffers: { id: string; name: string; applicableType: 'for_visitors' | 'for_success_customer' }[]
  fairPrimaryDates: { primaryDate: Date }[]
  bridalFairParticularDetails: {
    particularDate: Date
    name: string
    mainImageUrl: string
    descriptionText: string
  }[]
  netResvDeadlineDays: number
  netResvDeadlineTime: string
}

export type BridalFairDate = {
  date: Date
  fairEvents: FairEvent[]
}

export type FairEvent = {
  bridalFairDetailKey: string
  isEdited: boolean
  isNetReservable: boolean
  name: string
  mainImageUrl: string
  mainImageData: ImageDataProps | null
  descriptionText: string
  tags: string[]
  contents: string[]
  withSpecialOffers: {
    forVisitor: boolean
    forSuccessCustomer: boolean
  }
  minutes: number
  fairTimes: FairTime[]
  pricing: 'free' | 'paid' | 'partially_paid'
}

export type SearchFormType = {
  targetDates: MultiDateInputFieldValue
  targetTagNames: string[]
  targetContentNames: string[]
  targetSpecialOfferNames: string[]
}

export type RecommendedFair = BridalFairDetail & { fairTimes: FairTime[] } & { minutes: number }

export type ImageDataProps = {
  url: string
  oneToOneImage?: { url: string }
  threeToTwoImage?: { url: string }
  fourToThreeImage?: { url: string }
  sixteenToNineImage?: { url: string }
}

export type PickupParticularFair = {
  name: string
  id: string
  isPrimary: boolean
  particularDate: string
  imageUrl: string
  imageData: ImageDataProps | null
  fairTimes: FairTime[]
  bridalFairDetail: {
    key: string
    order: number
    pricing: 'free' | 'paid' | 'partially_paid'
    numberOfPeople: number
    netResvDeadlineDays: number
    netResvDeadlineTime: string
  }
  bridalFair: {
    minutes: number
  }
}

export type RawBridalFairParticularDetail = {
  id: string
  isIndividuallyEdited: boolean
  isPrimary: boolean
  isNetReservable: boolean
  particularDate: string
  name: string
  descriptionText: string
  imageUrl: string
  imageData: ImageDataProps | null
  pricing: 'free' | 'paid' | 'partially_paid'
  numberOfPeople: number
  price: number
  pricingDescriptionText: string
  bridalFairDetail: {
    key: string
    order: number
    name: string
    descriptionText: string
    pricing: 'free' | 'paid' | 'partially_paid'
    numberOfPeople: number
    price: number
    pricingDescriptionText: string
    netResvDeadlineDays: number
    netResvDeadlineTime: string
    fairContents: {
      name: string
      descriptionText: string
      order: number
    }[]
    fairTags: {
      name: string
    }[]
    bridalSpecialOffers: {
      name: string
      descriptionText: string
      order: number
      applicableType: 'for_visitors' | 'for_success_customer'
    }[]
  }
  bridalFair: {
    minutes: number
  }
  fairTimes: {
    startAt: string
    availability: 'none' | 'few' | 'lot'
  }[]
}

export const pricingLabels = {
  free: '無料',
  paid: '有料',
  partially_paid: '一部有料',
} as const
